import { render, staticRenderFns } from "./UpdateStatus.vue?vue&type=template&id=507209f8&scoped=true"
import script from "./UpdateStatus.vue?vue&type=script&lang=js"
export * from "./UpdateStatus.vue?vue&type=script&lang=js"
import style0 from "./UpdateStatus.vue?vue&type=style&index=0&id=507209f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507209f8",
  null
  
)

export default component.exports